module.exports = __webpack_public_path__ + "img/band-aid.cc2c356e.svg";